




















import { Component, Prop, Vue } from 'vue-property-decorator';
// import { FormItem } from 'element-ui';
@Component({
  name: 'lb-form-item'
  // components: {
  //   'el-form-item': FormItem
  // }
})
export default class extends Vue {
  @Prop() private label!: string;
  @Prop() private labelWidth!: string;
  @Prop() private prop!: string;
  @Prop({ type: Boolean, default: undefined }) private required!: boolean;
  @Prop() private rules!: any;
  @Prop() private error!: string;
  @Prop() private validateStatus!: string;
  @Prop() private for!: string;
  @Prop({ default: '' }) private inlineMessage!: string | boolean;
  @Prop({ type: Boolean, default: true }) private showMessage!: boolean;
  @Prop() private size!: string;

  private resetField() {
    // @ts-ignore
    this.$refs.lbForm.resetField();
  }

  private clearValidate() {
    // @ts-ignore
    this.$refs.lbForm.clearValidate();
  }
}
